import React from 'react'

const ClearanceLabelsPrintPreview = ({ printList, layout = 'detailed' }) => {
  if (!printList || printList.length === 0) {
    return null
  }

  const isClassic = layout === 'classic'
  const itemsPerPage = isClassic ? 9 : 21

  return (
    <div className="print-only-content">
      {Array.from({ length: Math.ceil(printList.length / itemsPerPage) }).map((_, pageIndex) => {
        const startIdx = pageIndex * itemsPerPage
        const pageItems = printList.slice(startIdx, startIdx + itemsPerPage)

        return (
          <div
            key={pageIndex}
            className={`clearance-labels-a4-container${isClassic ? ' clearance-labels-a4-container--classic' : ''}`}
          >
            {pageItems.map((item, itemIndex) => (
              <div key={itemIndex} className="clearance-label-item">
                <div className="label-content">
                  {isClassic ? (
                    <>
                      <div className="label-now">now</div>
                      <div className="label-current-price">
                        <span className="currency-symbol">₱</span>
                        {item.currentPrice.toFixed(0)}
                      </div>
                      <div className="label-was">was</div>
                      <div className="label-was-price">
                        <span className="currency-symbol">₱</span>
                        <span className="was-price-value">{item.wasPrice.toFixed(0)}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      {item.productDescription && (
                        <div className="label-description">{item.productDescription}</div>
                      )}
                      <div className="label-prices-row">
                        <div className="label-was-section">
                          <div className="label-was">was</div>
                          <div className="label-was-price">
                            <span className="currency-symbol">₱</span>
                            <span className="was-price-value">{item.wasPrice.toFixed(0)}</span>
                          </div>
                        </div>
                        <div className="label-now-section">
                          <div className="label-now">now</div>
                          <div className="label-current-price">
                            <span className="currency-symbol">₱</span>
                            {item.currentPrice.toFixed(0)}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="label-keycode">{item.apn}</div>
              </div>
            ))}
          </div>
        )
      })}
    </div>
  )
}

export default ClearanceLabelsPrintPreview
